import { useMemo, useState } from "react";
import { Tooltip } from "@mui/material";

const LazyTooltip = ({ title, children, ...props }) => {
  const [open, setOpen] = useState(false);
  const resolvedTitle = useMemo(() => (open ? title : ""), [open, title]);

  return (
    <Tooltip
      {...props}
      title={resolvedTitle}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    >
      {children}
    </Tooltip>
  );
};

export default LazyTooltip;
